var map = {
	"./pantalla-8-1.png": "adfb",
	"./pantalla-8-2.png": "e48e",
	"./pantalla-8-3.png": "5d32",
	"./pantalla-8-4.png": "aa33",
	"./pantalla-8-5.png": "0fdd",
	"./pantalla-8-6.png": "3a52",
	"./pantalla-8-7.png": "c7e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2c66";